import { defineComponent, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { showNotify } from "vant";
import { getCompanyList, getDeptList, getPersonList } from "@/api/visitor";
import { showLoadingToast, closeToast } from "vant";
import Bus from "@/utils/eventBus";
export default defineComponent({
  name: "VisitorSearch",
  setup() {
    const router = useRouter();
    const route = useRoute();
    let title = ref("企业");
    let fieldVal = "company";
    let list = ref();
    const searchValue = ref("");
    const checked = ref();
    let queryParams = {
      companyId: "",
      deptId: ""
    };
    watch(() => route === null || route === void 0 ? void 0 : route.query, val => {
      const {
        field,
        companyId,
        deptId,
        title: titleVal
      } = val;
      title.value = titleVal;
      // Object.keys(val).map()
      queryParams = {
        companyId,
        deptId
      };
      fieldVal = field;
      // companyId
      //   ? (queryParams.companyId = companyId)
      //   : delete queryParams.companyId;
      // deptId ? (queryParams.deptId = deptId) : delete queryParams.deptId;
    }, {
      immediate: true
    });
    const onSearch = () => {
      if (searchValue.value.length < 2) {
        showNotify({
          type: "warning",
          message: "至少输入2个文字才能进行搜索！"
        });
        return;
      }
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      // const method =
      //   field == "dept"
      //     ? getDeptList
      //     : field == "person"
      //     ? getPersonList
      //     : getCompanyList;
      if (fieldVal == "dept") {
        getDeptList({
          companyId: queryParams.companyId,
          searchValue: searchValue.value
        }).then(({
          data,
          code
        }) => {
          if (code == 200) {
            list.value = data;
          }
        }).finally(() => {
          closeToast();
        });
      } else if (fieldVal == "interviewer") {
        getPersonList({
          companyId: queryParams.companyId,
          deptId: queryParams.deptId,
          searchValue: searchValue.value
        }).then(({
          data,
          code
        }) => {
          if (code == 200) {
            list.value = data;
          }
        }).finally(() => {
          closeToast();
        });
      } else {
        getCompanyList({
          searchValue: searchValue.value
        }).then(({
          data,
          code
        }) => {
          if (code == 200) {
            list.value = data;
          }
        }).finally(() => {
          closeToast();
        });
      }
    };
    const onCellCiick = item => {
      checked.value = item.id;
      router.go(-1);
      // localStorage.setItem(
      //   "searchChange" + fieldVal,
      //   JSON.stringify({ field: fieldVal, ...item })
      // );
      Bus.$emit("searchChange", {
        field: fieldVal,
        ...item
      });
    };
    return {
      searchValue,
      title,
      list,
      onSearch,
      checked,
      onCellCiick
    };
  }
});